import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {MatSnackBar} from '@angular/material/snack-bar';
import {BackendListModel} from 'src/app/models/common/list.model';
import {UserMasterApiService} from 'src/app/services/domain_code/user-master-api.service';
import {NavService} from 'src/app/services/nav.service';
import {WarningBoxComponent} from '../../dialog-box/warning-box/warning-box.component';
import {AuthService} from "../../../services/auth.service";

@Component({
    selector: 'logzy-my-preferences',
    templateUrl: './my-preferences.component.html',
    styleUrls: ['./my-preferences.component.scss']
})
export class MyPreferencesComponent implements OnInit {
    isDefaultPageEditable: boolean = false;
    isSkipLandingPage: boolean = false;
    pageList: BackendListModel<any>;
    selectedMenu;
    current_default_page;
    error: any = {};
    skipTutorial: boolean = false;

    constructor(public navService: NavService,
                private userService: UserMasterApiService,
                private snackBar: MatSnackBar,
                private dialog: MatDialog,
                protected authService: AuthService) {
    }

    ngOnInit(): void {
        this.current_default_page = JSON.parse(localStorage.getItem('current_user')).default_page;
        this.skipTutorial = JSON.parse(localStorage.getItem('current_user')).skip_tutorial;
        this.getPageList();
    }

    getPageList() {
        this.navService.getListofPageUrls().subscribe({
            next: res => {
                this.pageList = res;
                this.currentDefaultPage();
            },
            error: err => {
                console.log(err)
            }
        })
    }

    currentDefaultPage() {
        if (this.current_default_page != null && this.pageList) {
            for (let i = 0; i < this.pageList.results.length; i++) {
                if (this.current_default_page.id === this.pageList.results[i].id) {
                    this.selectedMenu = this.pageList.results[i];
                }
            }
        }
    }

    editableToggle() {
        if (this.isDefaultPageEditable) {
            this.openWarningOnSave(`You are choosing ${this.selectedMenu ? this.selectedMenu.name : 'Default' +
                ' Dashboard'} as your landing page upon login.`, ' You can change it anytime later.', 'Back', 'I understand', 'page');
        } else {
            this.isDefaultPageEditable = true;
        }
    }

    editableLandingToggle() {
        if (this.isSkipLandingPage) {
            this.openWarningOnSave(this.skipTutorial ? `You are choosing to skip landing page` : `You are choosing to show Landing page. This will add an additional step to access list page.`, ' You can change' +
                ' it anytime later.', 'Back', 'I understand', 'skip');
        } else {
            this.isSkipLandingPage = true;
        }
    }

    saveLandingPage() {
        // let data = {
        //     default_page: this.selectedMenu ? this.selectedMenu.id : null,
        // }

        this.userService.updateLandingPage({default_page: this.selectedMenu ? this.selectedMenu.id : null}).subscribe({
            next: res => {
                this.snackBar.open("Default Landing Page Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                this.setDefaultPage(this.selectedMenu)
                this.isDefaultPageEditable = false;
                return res;
            },
            error: err => {
                console.log(err);
                this.error = {...err.error}
                return err;
            }
        })

    }

    skipTutorials() {
        this.userService.skipTutorialPage({skip_tutorial: this.skipTutorial}).subscribe({
            next: res => {
                this.snackBar.open("Data Updated Successfully!", 'Close', {
                    verticalPosition: 'top',
                    duration: 3000,
                });
                let current_user = JSON.parse(localStorage.getItem('current_user'));
                current_user.skip_tutorial = this.skipTutorial;
                localStorage.setItem('current_user', JSON.stringify(current_user));
                this.isSkipLandingPage = false;
                setTimeout(() => {
                    this.navService.landingPage.next(this.skipTutorial);
                }, 2000)
                return res;
            },
            error: err => {
                console.log(err);
                this.error = {...err.error}
                return err;
            }
        })
    }

    openWarningOnSave(label: string, description, action1: string, action2?: string, type?: string) {
        const dialogRef = this.dialog.open(WarningBoxComponent, {
            panelClass: 'dialog-container-custom',
            disableClose: true,
            data: {subTitle: label, parent: this, description: description, label1: action1, label2: action2}
        });

        dialogRef.afterClosed().subscribe(item => {
            if (item) {
                if (type == 'page')
                    this.saveLandingPage();
                if (type == 'skip')
                    this.skipTutorials();
            } else {
                return;
            }
        })
    }

    setDefaultPage(new_default_page) {
        let current_user = JSON.parse(localStorage.getItem('current_user'));
        current_user.default_page = {...new_default_page}
        localStorage.setItem('current_user', JSON.stringify(current_user));
    }
}
